import api from "./api";

const buildResourceFormData = (data) => {
  const formData = new FormData();

  if (data.resource_id !== undefined) {
    formData.append("resource_id", String(data.resource_id));
  }
  if (data.experience !== undefined) {
    formData.append("experience", String(data.experience));
  }
  if (data.first_name !== undefined) {
    formData.append("first_name", data.first_name);
  }
  if (data.last_name !== undefined) {
    formData.append("last_name", data.last_name);
  }
  if (data.email !== undefined) {
    formData.append("email", data.email);
  }
  if (data.contact_number !== undefined) {
    formData.append("contact_number", data.contact_number);
  }
  if (data.summary !== undefined) {
    formData.append("summary", data.summary ?? "");
  }
  if (data.role_id !== undefined && data.role_id !== null) {
    formData.append("role_id", data.role_id);
  }
  if (data.skills !== undefined) {
    formData.append("skills", JSON.stringify(data.skills || []));
  }
  if (data.categories !== undefined) {
    formData.append("categories", JSON.stringify(data.categories || []));
  }
  if (data.projects !== undefined) {
    formData.append("projects", JSON.stringify(data.projects || []));
  }

  const categoryCvUploads = data.categoryCvUploads || {};
  Object.entries(categoryCvUploads).forEach(([categoryId, file]) => {
    if (file) {
      formData.append(`category_cv_${categoryId}`, file);
    }
  });

  return formData;
};

export const resourcesService = {
  getAll: async (
    page = 1,
    limit = 10,
    search = "",
    sortBy = "first_name",
    sortOrder = "asc",
  ) => {
    const response = await api.get("/api/admin/resources", {
      params: { page, limit, search, sortBy, sortOrder },
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/api/admin/resources/${id}`);
    return response.data;
  },

  create: async (data) => {
    const formData = buildResourceFormData(data);
    const response = await api.post("/api/admin/resources", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  update: async (id, data) => {
    const formData = buildResourceFormData(data);
    const response = await api.patch(`/api/admin/resources/${id}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/api/admin/resources/${id}`);
    return response.data;
  },
};
